import React from 'react';
import { H1 } from '../../components/elements/Text';
import Navbar from '../../components/Navbar';
import PageWithAsyncData from '../../components/PageWithAsyncData';
import PageWrapper from '../../components/PageWrapper';
import styled from 'styled-components';
import { useGetCompany } from '../../hooks/use-hydra/admin';

import { useParams } from 'react-router-dom';
import Button from '../../components/elements/Button';
import day from 'dayjs';
import utc from 'dayjs/plugin/utc';
import Cohort from '../../components/Admin/Cohort';
import AddCohortModal from '../../components/Admin/Modals/AddCohortModal';
day.extend(utc);

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const Header = ({ name, id }: { name?: string; id?: string }) => (
  <Navbar
    breadCrumbs={[
      {
        label: 'Home',
        url: '/',
      },
      {
        label: 'Companies',
        url: '/admin/companies',
      },
      ...(name && id ? [{ label: name, url: `/admin/companies/${id}` }] : []),
      { label: 'Cohorts', url: null },
    ]}
  />
);

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  margin-bottom: 72px;
`;

const AddCohortButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Button
      type="secondary"
      onClick={onClick}
      label="Add Cohort"
      showIconBeforeLabel
      faIcon="fa-solid fa-plus"
    />
  );
};

export default function Cohorts() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, error, refetch } = useGetCompany(parseInt(id));
  const [isAddCohortModalOpen, setIsAddCohortModalOpen] = React.useState(false);
  return (
    <PageWithAsyncData isLoading={isLoading} error={error} retry={refetch}>
      <Header name={data?.name} id={id} />
      <PageWrapper>
        <H1>{data?.name} Cohorts</H1>
        <Content>
          <Row>
            <AddCohortButton onClick={() => setIsAddCohortModalOpen(true)} />
          </Row>
          <CohortsWrapper>
            {data?.cohorts.map((cohort) => (
              <Cohort
                key={cohort.cycleId}
                cohort={cohort}
                companyId={parseInt(id)}
              />
            ))}
          </CohortsWrapper>
        </Content>
      </PageWrapper>
      <AddCohortModal
        isOpen={isAddCohortModalOpen}
        onClose={() => setIsAddCohortModalOpen(false)}
      />
    </PageWithAsyncData>
  );
}

const CohortsWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 64px;
`;
